// UPLOAD
export const apiUploadFile = "/chuyendoiso/api/v1/UploadFiles"
